/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A validation problem found in an uploaded skill manifest.
 */
export type SkillValidationError = {
  /**
   * A stable validation error code.
   */
  code: string;
  /**
   * The manifest field associated with the problem.
   */
  field: string;
  /**
   * A human-readable explanation of the problem.
   */
  message: string;
};

/** @internal */
export const SkillValidationError$inboundSchema: z.ZodMiniType<
  SkillValidationError,
  unknown
> = z.object({
  code: z.string(),
  field: z.string(),
  message: z.string(),
});

export function skillValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<SkillValidationError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillValidationError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillValidationError' from JSON`,
  );
}
